import Coin from '@ltypes/asset';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const cryptoSlice = createSlice({
    name: 'crypto',
    initialState: null as Array<Coin>|null,
    reducers: {
        updateCoinsList: (state, action: PayloadAction<Array<Coin>>) => {
            return action.payload;
        },
    }
});

export const { updateCoinsList } = cryptoSlice.actions;

export default cryptoSlice.reducer;